import { ICallLog, ICaseDetail, ICaseReferral, ICasesCount, IEnvelope } from '../../types/cases';
import { ICampaign, CampaignItemType } from '../../types/campaigns';
import { IUserProfile } from '../../types/user';
import { Api } from '../api';

//TODO: Improve requests handle as GetUserProfile
export async function CasesAssignedRequest(page?: number, pageSize?: number, status?: string) {
    try {
        const request = await Api.get(
            `cases/assigned?page=${page ? page : 0}${pageSize ? '&per_page=' + pageSize : ''}${
                status ? '&status=' + status : ''
            }`
        );

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function CasesReferred(page?: number, status?: string): Promise<ICaseReferral[]> {
    try {
        const request = await Api.get(
            `cases/referred?page=${page ? page : 0}&per_page=20${status ? '&status=' + status : ''}`
        );

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function CasesReferredCount(from: string): Promise<ICasesCount> {
    try {
        const request = await Api.get(`cases/referred/count${from !== '?status=' ? from : ''}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function CasesCount() {
    try {
        const request = await Api.get('cases/assigned/count');

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function CasesSharedRequest(page?: number, pageSize?: number) {
    try {
        const request = await Api.get(`cases/shared?page=${page ? page : 0}&per_page=${pageSize ? pageSize : 20}`);

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function CasesSharedCount() {
    try {
        const request = await Api.get('cases/shared/count');

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function GetCasesCount(from: string) {
    try {
        const request = await Api.get(`cases/assigned/count${from !== '?status=' ? from : ''}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCasesFollowUp(page?: number, pageSize?: number) {
    try {
        const request = await Api.get(`cases/follow-up?page=${page ? page : 0}&per_page=${pageSize ? pageSize : 20}`);

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function CasesFollowUpCount() {
    try {
        const request = await Api.get('cases/follow-up/count');

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function GetCase(caseId: string | number) {
    try {
        const request = await Api.get(`case/${caseId}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetRejectionReasons(): Promise<string[]> {
    try {
        const request = await Api.get('case/rejection-reasons');

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function GetCaseStatuses() {
    try {
        const request = await Api.get('case/intake-statuses');
        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetReferralStatuses() {
    try {
        const request = await Api.get('case/referral-statuses');
        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetDeclineReasons(): Promise<string[]> {
    try {
        const request = await Api.get('case/decline-reasons');

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function GetCaseTypes() {
    try {
        const request = await Api.get('case/types');

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function EditCase({ id, body }: { id: string | number; body: any }): Promise<ICaseDetail> {
    try {
        const request = await Api.put(`case/${id}`, { ...body });

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function FinishCase({ id, body }: { id: string | number; body: any }) {
    try {
        const request = await Api.post(`case/${id}`, { ...body });

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function UnrejectCase({ id }: { id: string | number }) {
    try {
        const request = await Api.put(`case/${id}/unreject`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function UnretainCase({ id }: { id: string | number }) {
    try {
        const request = await Api.put(`case/${id}/unretain`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function SearchCases(query: string) {
    try {
        const request = await Api.get(`search?query=${query}&page=0`);

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function GetComments(caseId: string | number) {
    try {
        const request = await Api.get(`case/${caseId}/comments`);

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function AddComment({ caseId, content }: { caseId: string | number; content: string }): Promise<any> {
    try {
        const request = await Api.post(`case/${caseId}/comments`, {
            content: content
        });

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function ShareCase({
    caseId,
    userId
}: {
    caseId: string | number;
    userId: string | number;
}): Promise<any> {
    try {
        const request = await Api.post(`case/${caseId}/share/${userId}`, {});

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function ReassignCase({
    caseId,
    userId
}: {
    caseId: string | number;
    userId: string | number;
}): Promise<any> {
    try {
        const request = await Api.put(`case/${caseId}/assign/${userId}`, {});

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function CaseSharedWith(id: string | number): Promise<IUserProfile[] | []> {
    try {
        const request = await Api.get(`case/${id}/shares`);

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function UnshareCase({
    caseId,
    userId
}: {
    caseId: string | number;
    userId: string | number;
}): Promise<any> {
    try {
        const request = await Api.delete(`case/${caseId}/share/${userId}`);

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function FinishIntake({ userId }: { userId: string | number }): Promise<any> {
    try {
        const request = await Api.delete(`users/${userId}/intake`, {});

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function GetCaseCalls(caseId: string | number): Promise<ICallLog[] | []> {
    try {
        const request = await Api.get(`case/${caseId}/calls`);

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

interface INewCase {
    first_name: string;
    phone: string;
    email?: string;
}

export async function CreateCase(caseData: INewCase) {
    try {
        const request = await Api.post(`case`, caseData);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function GetCasesByGroup(groupId: number | string, page?: number, status?: string) {
    try {
        const request = await Api.get(
            `cases/group/${groupId}?page=${page ? page : 0}&per_page=20${status ? '&status=' + status : ''}`
        );

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetTotalCasesByGroup(groupId: number | string, from?: string) {
    try {
        const request = await Api.get(`cases/group/${groupId}/count${from}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCasesByIntakeManagerID(id: number | string, page?: number, status?: string) {
    try {
        const request = await Api.get(
            `cases/intake-manager/${id}?page=${page ? page : 0}&per_page=20${status ? '&status=' + status : ''}`
        );

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetTotalCasesByIntakeManagerID(id: number | string, from?: string) {
    try {
        const request = await Api.get(`cases/intake-manager/${id}/count${from}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCasesByAll(page?: number, status?: string, fromDate?: string, toDate?: string) {
    try {
        const request = await Api.get(
            `cases/all?page=${page ? page : 0}&per_page=20${status ? '&status=' + status : ''}${
                fromDate ? '&from_date=' + fromDate : ''
            }${toDate ? '&to_date=' + toDate : ''}`
        );

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetTotalCasesByAll(status?: string, fromDate?: string, toDate?: string) {
    try {
        const request = await Api.get(`cases/all/count?${status}&${fromDate}&${toDate}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetDashboardsByAll() {
    try {
        const request = await Api.get(`dashboards/all`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetDashboard(name: string) {
    try {
        const request = await Api.get(`dashboards/${name}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCampaignsByAll() {
    try {
        const request = await Api.get(`cases/campaigns`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCampaign(id: number | string): Promise<ICampaign | Error> {
    try {
        const request = await Api.get(`cases/campaigns/${id}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCaseQuestions(id: number | string) {
    try {
        const request = await Api.get(`case/${id}/questions`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

interface INewCampaign {
    name: string;
}

export async function AddCampaign(campaignData: INewCampaign) {
    try {
        const request = await Api.post(`cases/campaigns`, campaignData);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function UpdateCampaign(
    campaignId: number | string,
    data: {
        name: string;
    }
) {
    try {
        const request = await Api.put(`cases/campaigns/${campaignId}`, data);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function DeleteCampaign(campaignId: number | string) {
    try {
        const request = await Api.delete(`cases/campaigns/${campaignId}`);

        return request.data;
    } catch (error) {
        return error;
    }
}

interface IQuestion {
    content: string;
    required: boolean;
    type: CampaignItemType;
}

export async function AddQuestion(campaignId: number | string, question: IQuestion) {
    try {
        const request = await Api.post(`cases/campaigns/${campaignId}/questions`, question);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function UpdateQuestion(campaignId: number | string, questionId: number | string, question: IQuestion) {
    try {
        const request = await Api.put(`cases/campaigns/${campaignId}/questions/${questionId}`, question);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function UpdateQuestionPosition(
    campaignId: number | string,
    questionId: number | string,
    position: number
) {
    try {
        const request = await Api.put(`cases/campaigns/${campaignId}/questions/${questionId}/position/${position}`);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function AnswerQuestion(caseId: number | string, questionId: number | string, question: IQuestion) {
    try {
        const request = await Api.post(`case/${caseId}/questions/${questionId}/answer`, question);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function DeleteQuestion(campaignId: number | string, questionId: number | string) {
    try {
        const request = await Api.delete(`cases/campaigns/${campaignId}/questions/${questionId}`);

        return request.data;
    } catch (error) {
        return error;
    }
}

export async function SendRejectionSMS({ caseId }: { caseId: string | number }): Promise<any> {
    try {
        const request = await Api.post(`case/${caseId}/rejection-message`, {});

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function RequeueCase({ caseId }: { caseId: string | number }): Promise<any> {
    try {
        const request = await Api.post(`case/${caseId}/requeue`, {});

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function GetCaseFileList(caseId: string | number) {
    try {
        const request = await Api.get(`case/${caseId}/list-stored-files-paths`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetCaseFileLink(caseId: string | number, path: string) {
    try {
        const request = await Api.get(`case/${caseId}/get-gcs-file?path=${path}`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetReferralReviewStates() {
    try {
        const request = await Api.get('case/referral-review-states');

        return request.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export async function GetDocusignLink(caseId: string | number) {
    try {
        const request = await Api.get(`case/${caseId}/docusign`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetDocusignStatus(caseId: string | number) {
    try {
        const request = await Api.get(`case/${caseId}/docusign/status`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function GetDocusignEnvelope(caseId: string | number) {
    try {
        const request = await Api.get(`case/${caseId}/docusign/envelope`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function EditEnvelope({ id, body }: { id: string | number; body: any }): Promise<IEnvelope> {
    try {
        const request = await Api.put(`case/${id}/docusign/envelope`, { ...body });

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function SendEnvelope({ id, body }: { id: string | number; body: any }) {
    try {
        const request = await Api.post(`case/${id}/docusign/envelope`, { ...body });

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}

export async function ResendEnvelope({ id }: { id: string | number }) {
    try {
        const request = await Api.post(`case/${id}/docusign/envelope/resend`);

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error);
        }
        return error;
    }
}
